// Remplace ton composant LinkNav par cette version (séparation des états : menu mobile vs. Pages Club)

import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { IoIosMenu } from "react-icons/io";
import "./LinkNav.css";
import MegaMenu from "./MegaMenu";
import LogoSection from "./LogoSection";
import Modal from "./../../../hooks/Modal";
import { getSettings } from "../../../services/settingsServices";
import { getAllPages } from "./../../../services/pagesPersonnaliseesServices";
import { getAllAdherentsList } from "./../../../services/adherentServices";
import { getExercisesByAdherent } from "./../../../services/prepaPhysiqueServices";
import { getAdherentsByUser } from "./../../../services/adherentServices";

import { FaFacebookF, FaInstagram } from "react-icons/fa";

import {
  FaFutbol,
  FaFootballBall,
  FaTableTennis,
  FaBicycle,
  FaRunning,
  FaSwimmer,
  FaBasketballBall,
  FaVolleyballBall,
  FaGolfBall,
  FaHockeyPuck,
  FaMountain,
  FaSkiing,
} from "react-icons/fa";
import {
  GiKimono,
  GiFencer,
  GiTennisRacket,
  GiHorseHead,
  GiHighKick,
  GiBoxingGlove,
} from "react-icons/gi";
import {
  MdOutlineSportsHandball,
  MdRowing,
  MdOutlineSportsMartialArts,
  MdSportsKabaddi,
} from "react-icons/md";

const icons = {
  FaFutbol,
  FaFootballBall,
  FaTableTennis,
  FaBicycle,
  FaRunning,
  FaSwimmer,
  FaBasketballBall,
  MdOutlineSportsHandball,
  GiKimono,
  GiFencer,
  GiTennisRacket,
  GiBoxingGlove,
  FaVolleyballBall,
  GiHorseHead,
  FaGolfBall,
  FaHockeyPuck,
  GiHighKick,
  FaMountain,
  MdRowing,
  FaSkiing,
  MdOutlineSportsMartialArts,
  MdSportsKabaddi,
};

const LinkNav = ({ user }) => {
  const navigate = useNavigate();

  // ⚠️ NOUVEAU : on sépare les états pour éviter l’ouverture par défaut
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isPagesDropdownOpen, setIsPagesDropdownOpen] = useState(false);

  const [showMegaMenu, setShowMegaMenu] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const [settings, setSettings] = useState({
    display_boutique: true,
    display_chat: true,
    display_news: true,
    display_galerie: true,
    display_lexique: true,
    display_techniques: true,
    display_appels: true,
    display_todolist: true,
    display_coaching: true,
    display_heures_enseignants: true,
    display_inventaire: true,
    display_chat_admin: true,
    display_messages_admin: true,
    adresse_club: "",
    tel_club: "",
    mail_club: "",
    facebook_club: "",
    instagram_club: "",
  });

  const [IconComponent, setIconComponent] = useState(() => GiKimono);
  const [pagesActives, setPagesActives] = useState([]);
  const [exercicesRestants, setExercicesRestants] = useState(0);

  useEffect(() => {
    const fetchSettings = async () => {
      const data = await getSettings();
      if (data.length > 0) {
        setSettings(data[0]);
        const iconName = data[0].discipline_icone;
        if (iconName && icons[iconName]) {
          setIconComponent(() => icons[iconName]);
        }
      }
    };
    fetchSettings();
  }, []);

  useEffect(() => {
    const fetchPages = async () => {
      const pages = await getAllPages();
      const actives = pages.filter((page) => page.actif);
      setPagesActives(actives);
    };
    fetchPages();
  }, []);

  useEffect(() => {
    const fetchExercicesRestants = async () => {
      try {
        if (!user) return;

        const adherentsUser = await getAdherentsByUser();
        let total = 0;

        for (const adherent of adherentsUser) {
          const adherentWithExercises = await getExercisesByAdherent(
            adherent.id
          );

          if (
            adherentWithExercises &&
            Array.isArray(adherentWithExercises.Exercices)
          ) {
            const nonTermines = adherentWithExercises.Exercices.filter(
              (ex) => ex.AdherentPrepaPhysique?.is_done === false
            ).length;

            total += nonTermines;
          }
        }

        setExercicesRestants(total);
      } catch (err) {
        console.error("Erreur exercices restants :", err);
      }
    };

    fetchExercicesRestants();
  }, [user]);

  // --- Handlers ---
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen((prev) => !prev);
    if (isPagesDropdownOpen) setIsPagesDropdownOpen(false);
  };

  const toggleMegaMenu = () => {
    setShowMegaMenu((prev) => !prev);
    if (isMobileMenuOpen) setIsMobileMenuOpen(false);
    if (isPagesDropdownOpen) setIsPagesDropdownOpen(false);
  };

  // Défilement vers une ancre + fermeture du menu mobile
  const handleNavigate = (id) => {
    if (id === "accueil") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
    setIsMobileMenuOpen(false); // ferme uniquement le menu mobile
  };

  const handleInscription = (event) => {
    if (!user) {
      event.preventDefault();
      setShowModal(true);
    } else {
      setIsMobileMenuOpen(false); // ne touche pas au dropdown Pages Club
      navigate("/ajouter-inscription-adherent");
    }
  };

  return (
    <div
      className={`flex h-15 ${
        window.innerWidth < 400 ? "h-15" : ""
      } bg-white bg-opacity-85 text-black py-2 shadow-md items-center justify-between w-full gap-2`}
    >
      <div className="flex items-center ml-2">
        <NavLink to="/">
          <LogoSection />
        </NavLink>

        {/* Bouton menu mobile */}
        <div className="lg:hidden ml-4">
          <button
            onClick={toggleMobileMenu}
            aria-label="Menu"
            title="Menu"
            className="bg-primary text-white px-4 py-2 rounded-3xl shadow-sm transition duration-300 ease-in-out hover:bg-white hover:text-primary border border-primary flex items-center justify-center w-sm h-10 gap-2"
          >
            <IoIosMenu className="text-xl" />
            {window.innerWidth >= 400 && "Menu"}
          </button>
        </div>
      </div>

      {/* Menu déroulant mobile */}
      {isMobileMenuOpen && (
        <div className="dropdown-content backdrop-filter backdrop-blur-sm shadow absolute top-full left-0 py-2 z-20 w-full lg:hidden bg-white/50">
          <div className="flex flex-col items-center">
            {["accueil", "cours", "contact"].map((section) => (
              <NavLink
                key={section}
                to="/"
                state={{ scrollTo: section }}
                onClick={() => {
                  handleNavigate(section);
                }}
                className="block w-full px-4 py-3 text-xl hover:bg-primary hover:text-white text-black link-nav2 text-center"
              >
                {section.charAt(0).toUpperCase() + section.slice(1)}
              </NavLink>
            ))}

            <button
              onClick={handleInscription}
              className="block w-full px-4 py-3 text-xl hover:bg-primary hover:text-white text-black link-nav2 text-center"
            >
              Inscriptions
            </button>

            {pagesActives.length > 0 && (
              <div className="w-full text-center">
                <div className="font-semibold uppercase text-primary py-2">
                  Pages Club
                </div>
                {pagesActives.map((page) => (
                  <NavLink
                    key={page.id}
                    to={`/page/${page.slug}`}
                    onClick={() => setIsMobileMenuOpen(false)}
                    className="block w-full px-4 py-3 text-xl hover:bg-primary hover:text-white text-black link-nav2 text-center"
                  >
                    {page.titre}
                  </NavLink>
                ))}
              </div>
            )}

            <div className="flex flex-col items-center mt-4">
              <a
                href={`mailto:${settings.mail_club}`}
                className="text-black hover:text-primary"
              >
                {settings.mail_club}
              </a>
              <p className="text-black">{settings.tel_club}</p>
              <div className="flex space-x-4 mt-2">
                <a
                  href={settings.facebook_club}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-black hover:text-primary"
                >
                  <FaFacebookF />
                </a>
                <a
                  href={settings.instagram_club}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-black hover:text-primary"
                >
                  <FaInstagram />
                </a>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Navigation desktop */}
      <div className="hidden lg:flex space-x-6 grow justify-center mt-2">
        {["accueil", "cours", "contact"].map((section) => (
          <NavLink
            key={section}
            to="/"
            state={{ scrollTo: section }}
            onClick={() => handleNavigate(section)}
            className="link-nav2 uppercase font-montserrat font-medium hover:text-orange-600 text-black"
          >
            {section.charAt(0).toUpperCase() + section.slice(1)}
          </NavLink>
        ))}

        <NavLink
          to={user ? "/ajouter-inscription-adherent" : "/"}
          onClick={(e) => handleInscription(e)}
          className="link-nav2 uppercase font-montserrat font-medium hover:text-orange-600 text-black"
        >
          Inscription
        </NavLink>

        {pagesActives.length > 0 && (
          <div className="relative">
            <button
              onClick={() => setIsPagesDropdownOpen((v) => !v)}
              className="link-nav2 uppercase font-montserrat font-medium hover:text-orange-600 text-black"
            >
              Pages Club
            </button>

            {isPagesDropdownOpen && (
              <div className="absolute top-full left-0 mt-2 bg-white shadow-lg rounded min-w-[180px] z-20">
                {pagesActives.map((page) => (
                  <NavLink
                    key={page.id}
                    to={`/page/${page.slug}`}
                    onClick={() => setIsPagesDropdownOpen(false)}
                    className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                  >
                    {page.titre}
                  </NavLink>
                ))}
              </div>
            )}
          </div>
        )}
      </div>

      {user && (
        <div className="relative lg:flex items-center mr-2">
          <button
            onClick={toggleMegaMenu}
            aria-label="Application"
            title="Application"
            className="bg-primary text-white px-4 py-2 rounded-3xl shadow-sm transition duration-300 ease-in-out hover:bg-white hover:text-primary border border-primary flex items-center justify-center w-sm h-10 gap-2"
          >
            <IconComponent className="text-xl" />
            {window.innerWidth >= 400 && "Application"}
          </button>
          {showMegaMenu && (
            <div
              className="fixed inset-0 bg-black bg-opacity-50 z-50"
              onClick={() => setShowMegaMenu(false)}
            >
              <div
                className="absolute top-32 right-0 left-0 mx-auto w-full max-w-[1280px] px-4 shadow-xl"
                onClick={(e) => e.stopPropagation()}
              >
                <MegaMenu
                  role_id={user.role_id}
                  settings={settings}
                  onClose={() => setShowMegaMenu(false)}
                  exercicesRestants={exercicesRestants}
                />
              </div>
            </div>
          )}
        </div>
      )}

      {showModal && (
        <Modal title="Inscription Adhérent" onClose={() => setShowModal(false)}>
          <div className="text-center space-y-4">
            <p>
              Merci de vous connecter à votre compte ou de vous inscrire pour
              faire une adhésion.
            </p>
            <div className="flex justify-around p-4">
              <button
                onClick={() => {
                  setShowModal(false);
                  setIsMobileMenuOpen(false);
                }}
                className="bg-primary text-white px-4 py-2 rounded-3xl shadow-sm transition duration-300 ease-in-out hover:bg-white hover:text-primary border border-primary"
              >
                Annuler
              </button>
              <button
                onClick={() => {
                  setShowModal(false);
                  setIsMobileMenuOpen(false);
                  navigate("/login");
                }}
                className="bg-primary text-white px-4 py-2 rounded-3xl shadow-sm transition duration-300 ease-in-out hover:bg-white hover:text-primary border border-primary"
              >
                Se connecter
              </button>
              <button
                onClick={() => {
                  setShowModal(false);
                  setIsMobileMenuOpen(false);
                  navigate("/register");
                }}
                className="bg-primary text-white px-4 py-2 rounded-3xl shadow-sm transition duration-300 ease-in-out hover:bg-white hover:text-primary border border-primary"
              >
                S'inscrire
              </button>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default LinkNav;
